
const initAutoComplete = () => {
	const { restUrl } = window.EmClient;
	const input = document.querySelector('.em-doctor-finder__search-field');
	if (!input) return;

	const resultsContainer = document.querySelector('.em-doctor-finder__autocomplete');

	if (input && resultsContainer) {
		const clearResults = () => {
			resultsContainer.classList.remove('active');
			resultsContainer.innerHTML = '';
		};

		const fetchDoctors = (title, peopleTypes) => {
			(async () => {
				const response = await fetch(`${restUrl}wp/v2/em-people?peopleTypes=${peopleTypes}&title=${title}&per_page=5`);
				const data = await response.json();

				if (data.length) {
					let listItems = '';
					data.forEach((item) => {
						listItems += `<a href="${item.link}">${item.title.rendered}</a>`;
					});

					resultsContainer.classList.add('active');
					resultsContainer.innerHTML = listItems;
				} else {
					clearResults();
				}
			})();
		};

		input.addEventListener('keyup', function () {
			if (this.value.length > 0) {
				const wrapper = document.querySelector('.em-doctor-finder__wrapper');
				const peopleTypes = wrapper.dataset.includeTypes;

				fetchDoctors(this.value, peopleTypes);
			} else {
				clearResults();
			}
		});

		input.addEventListener('click', () => {
			if (resultsContainer.childNodes.length) {
				resultsContainer.classList.add('active');
			}
		});

		document.addEventListener('click', (e) => {
			if (!e.target.closest('.em-doctor-finder__search')) {
				resultsContainer.classList.remove('active');
			}
		});
	}
};

export default initAutoComplete;
